<template>
  <div class="d-inline-block social-icons">
    <div>
      <!-- <v-btn :href="item.Url" light icon class="primary"  v-for="(item,index) in socialIcons" :key="index" target="blank">
         <v-icon light >{{item.Fa_Icon}}</v-icon>
      </v-btn>-->
      <v-btn
        light
        icon
        class="primary"
        @click="navigateSocialPage(item.Url,item.Name)"
        v-for="(item,index) in socialIcons"
        :key="index"
      >
        <v-icon light>{{item.Fa_Icon}}</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: "SocialShare",
  props: ["socialIcons"],
  data() {
    return {};
  },
  methods: {
    navigateSocialPage(url, name) {
      this.$emit("socialMediaPost", name);
      if (url.includes("?")) {
        var fullUrl = url + "=" + encodeURIComponent(window.location.href);
        window.open(fullUrl, "_blank");
      } else {
        window.open(url, "_blank");
      }
    },
  },
};
</script>